import styled from "styled-components";
import { AVATAR_SIZE, INPUT_WRAPPER_MAX_WIDTH } from "../../../../constants";

export const ItemWrapper = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.medium,
}));

export const Avatar = styled.div(({ theme }) => ({
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
    borderRadius: theme.cornerRadius.rounded,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
}));

export const InfoSection = styled.div(({ theme }) => ({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xxSmall,
    minWidth: 0,
}));

export const InputWrapper = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.xxSmall,
    maxWidth: INPUT_WRAPPER_MAX_WIDTH,
}));
